var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSponsorsWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6014 16.2243C15.2137 16.0998 15.792 15.8589 16.2682 15.5017C17.5948 14.5298 17.5948 12.9267 16.2682 11.9548C15.8005 11.606 15.2307 11.3734 14.627 11.2405",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54344 11.7052C0.485519 13.0509 0.485519 15.2438 2.54344 16.5811C4.88199 18.1095 8.71721 18.1095 11.0558 16.5811C13.1137 15.2355 13.1137 13.0426 11.0558 11.7052C8.72572 10.1852 4.8905 10.1852 2.54344 11.7052Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9602 2.93359C14.61 2.93359 15.9366 4.23771 15.9366 5.84085C15.9366 7.41077 14.661 8.68997 13.0708 8.74811C13.0027 8.7398 12.9262 8.7398 12.8497 8.74811",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79524 8.64053C6.7102 8.63222 6.60816 8.63222 6.51461 8.64053C4.4907 8.57408 2.88348 6.95432 2.88348 4.96077C2.88348 2.92569 4.56724 1.27271 6.65918 1.27271C8.74261 1.27271 10.4349 2.92569 10.4349 4.96077C10.4264 6.95432 8.81915 8.57408 6.79524 8.64053Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsorsWhiteIcon);
export default __webpack_public_path__ + "static/media/sponsors_white_icon.17b4549f28491d896dfd4870127f3f3e.svg";
export { ForwardRef as ReactComponent };